/**
 * Generic payload interfaces
 */
export abstract class LoginPayload {
  constructor(protected username: string) {}

  abstract getPayload(): UserGenericPayload;
}


export interface UserGenericPayload {
  username: string;
  rememberMe: boolean;
}
